import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import Select from "react-select";
import { AccessType } from "@quintype/components";
import { connect } from "react-redux";
import { IS_OPEN_LOGIN_FORM, SELECTED_PLAN, PAYMENT_CHECKOUT_PAGE } from "../../../helper/actions";
import { GiftSubscription } from "../../../atoms/icons/gift-susbcription";
import Loader from "../../../atoms/loader";
import IntegrationData from "../../../../../../config/integrations.js"
import "./subscription.m.css";

class SubscriptionTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSubscriptions: {},
      activeTab: this.props.checkoutActiveTab === "gift-subscription" ? "tab-2" : "tab-1",
      userSubscriptions: [],
      isAccesstypeLoaded: false,
      selectFirstPlan: {}
    };
    this.handleSubscriptionClick = this.handleSubscriptionClick.bind(this);
  }

  componentDidMount() {
    this.mountedRoute = window.location.href;
    const userSubscription = () => this.getSubscription();
    this.props.initAccessType(userSubscription);
    this.props.selectedPlan({});
  }

  componentDidUpdate() {
    const newRoute = window.location.href;

    if (newRoute !== this.mountedRoute) {
      const activeTab = newRoute.indexOf("gift-subscription") > -1 ? "tab-2" : "tab-1";

      this.manageTab(activeTab);

      this.mountedRoute = newRoute;
    }
  }

  async getSubscription() {
    const response = await this.props.getSubscriptionForUser();
    this.setState({ userSubscriptions: response.subscriptions, isAccesstypeLoaded: true });
  }

  getDurationBlock(subscriptionGroup) {
    const plans = get(subscriptionGroup, ["subscription_plans"], []);
    const subscriptionGroupId = get(subscriptionGroup, ["id"]);

    var options = plans
      .filter(plan => plan.description.split(",")[0] !== "null")
      .map((plan, index) => {
        return { value: `${JSON.stringify(plan)}`, label: `${plan.title}` };
      });
    const colourStyles = {
      option: (styles, { isDisabled, isFocused, isSelected }) => {
        return {
          ...styles,
          backgroundColor: isDisabled ? null : isSelected ? "#fff" : isFocused ? "#fff" : null,
          color: isDisabled ? null : isSelected ? "#c00" : isFocused ? "#000" : null
        };
      }
    };

    const planList = plans.length > 0 && (
      <div styleName="select-wrapper">
        <Select
          options={options}
          onChange={e => this.handlePlanChange(e, subscriptionGroupId)}
          defaultValue={options[0]}
          className="basic-single"
          classNamePrefix="select"
          styles={colourStyles}
          isSearchable={false}
        />
      </div>
    );
    return <div>{planList}</div>;
  }

  getPriceBlock(subscriptionGroups, currentGroupIndex) {
    const firstPlan = get(subscriptionGroups, [currentGroupIndex, "subscription_plans"]).filter(item=>item.description !== "null");
    const firstPlanPrice = get(firstPlan, [0, "price_cents"], null);
    if(!firstPlanPrice) {
      return 0;
    }
    return (
      get(
        this.state,
        ["selectedSubscriptions", subscriptionGroups[currentGroupIndex].id, "price_cents"],
        firstPlanPrice
      ) / 100
    );
  }

  getPlanDuration(subscriptionGroups, currentGroupIndex) {
    const firstPlan = get(subscriptionGroups, [currentGroupIndex, "subscription_plans"]).filter(item=>item.description !== "null");

    const firstPlanUnit = get(firstPlan, [ 0, "duration_unit"]);
    const firstPlanDuration = get(firstPlan, [ 0, "duration_length"]);
    const planUnit = get(
      this.state,
      ["selectedSubscriptions", subscriptionGroups[currentGroupIndex].id, "duration_unit"],
      firstPlanUnit
    );
    const planDuration = get(
      this.state,
      ["selectedSubscriptions", subscriptionGroups[currentGroupIndex].id, "duration_length"],
      firstPlanDuration
    );
    console.log("planDuration--------", planDuration)
      console.log("planUnit------------------", planUnit)
    return (
      <span>
        <span styleName="plan-duration">{planDuration}</span>
        <span>{ planDuration=== 1 ? planUnit.slice(0, -1):  planUnit}</span>
      </span>
    );
  }

  getPlans = plans => {
    return plans
      .filter(plan => plan.description.split(",")[0] !== "null")
      .map((plan, index) => {
        return plan;
      });
  };


  handlePlanChange(e, subscriptionGroupId) {
    const currentPlan = JSON.parse(e.value);
    const currentState = Object.assign({}, this.state.selectedSubscriptions, { [subscriptionGroupId]: currentPlan });
    this.setState({ selectedSubscriptions: currentState });
  }

  addDefaultSrc(ev, imgUrl) {
    ev.target.src = imgUrl;
  }

  handleSubscriptionClick(e, subscriptionGroup) {
    e.preventDefault();
    e.stopPropagation();

    if (!this.props.member) {
      this.props.manageLoginForm(true);
      return false;
    }

    const options = this.getPlans(get(subscriptionGroup, ["subscription_plans"]));
    const selectedSubscriptionPlan = get(this.state, ["selectedSubscriptions", subscriptionGroup.id], options[0]);
    const urlParams = new URLSearchParams(window.location.search);
    const redirectUrl = urlParams.get("story-url") || "/subscription";
    this.props.selectedPlan(selectedSubscriptionPlan, redirectUrl, subscriptionGroup.subscription_plans);
    this.props.navigateTo(`/payment-checkout`);
    return true;
  }

  getSubscriptionBlocks(subscriptionGroups) {
    return subscriptionGroups.map((subscriptionGroup, index) => {
      if( subscriptionGroup["subscription_plans"].filter(item=>item.description!== "null").length < 1) {
        return null;
      }
      
      const description = (subscriptionGroup && subscriptionGroup.description.split("\n")) || [];
      const imageUrl =
        description && description.length > 0 ? description[0] : "https://dummyimage.com/120x120/c9c9c9/fff";
      const getDefaultImg = get(this.props.config, ["publisher", "publisher", "defaultSubImg"], "");
      const descriptionHeadline = description && description.length > 0 ? description[1] : "ENJOY THESE FEATURES";
      const hasSubscription =
        (this.state.userSubscriptions &&
          this.state.userSubscriptions.filter(userSub => userSub.subscription_group_id === subscriptionGroup.id)) ||
        [];
      return (
        <div styleName="group" key={`group-${index}`}>
          {hasSubscription.length > 0 && (
            <div styleName="current-plan-wrapper">
              <span styleName="current-plan">CURRENT PLAN</span>
              <span styleName="expiry-on">
                EXPIRES ON{" "}
                {new Date(hasSubscription[0].end_timestamp).toLocaleDateString("default", {
                  day: "numeric",
                  month: "short",
                  year: "numeric"
                })}
              </span>
            </div>
          )}
          <h3 styleName="group-name">{subscriptionGroup.name}</h3>
          <img
            onError={ev => this.addDefaultSrc(ev, getDefaultImg)}
            styleName="image"
            src={`${imageUrl}`}
            alt={subscriptionGroup.name}
          />
          <p styleName="plan-time">
            <span styleName="price">&#x20B9;{this.getPriceBlock(subscriptionGroups, index)} </span>
            {/* <span styleName="month">for {this.getPlanDuration(subscriptionGroups, index)}</span> */}
          </p>
          {this.getDurationBlock(subscriptionGroup)}
          {descriptionHeadline && <p styleName="description-headline">{descriptionHeadline}</p>}

          {description && description.length > 0 && (
            <ul styleName="feature">
              {description.slice(2, description.length).map((feature, index) => {
                return (
                  feature.length > 0 && (
                    <li styleName="feature-list" key={index + 1}>
                      {feature}
                    </li>
                  )
                );
              })}
            </ul>
          )}
          <div styleName="btn-wrapper">
            <button
              data-testid="plans-subscribe-btn"
              styleName="subs-btn"
              onClick={e => this.handleSubscriptionClick(e, subscriptionGroup)}
            >
              {this.state.activeTab === "tab-2"
                ? "GIFT SUBSCRIPTION"
                : hasSubscription.length > 0
                ? "₹ Renew"
                : "Subscribe"}
            </button>
          </div>
        </div>
      );
    });
  }

  manageTab(tab) {
    this.setState({ activeTab: tab });
    const paymentCheckoutPage = tab === "tab-2" ? "gift-subscription" : "subscription";
    this.props.paymentCheckout(paymentCheckoutPage);
  }

  render() {
    const planPageTitile = get(this.props.config, ["publisher", "publisher", "planPageTitle"], "").split(",");
    const planPageDescription = get(this.props.config, ["publisher", "publisher", "planPageDesc"], "");
    const groups = get(this.props, ["subscriptions"], []);
    const getStandardUser =
      (this.state.userSubscriptions &&
        this.state.userSubscriptions.filter(item => {
          return item.subscription_type === "standard";
        })) ||
      [];

    if (this.state.isAccesstypeLoaded === false) {
      return (
        <div styleName="loader">
          <Loader color="#ec2227" />
        </div>
      );
    }

    return groups && groups.length > 0 ? (
      <div className="full-width-with-padding" styleName="bg-wrapper">
        <div styleName="wrapper">
          {planPageTitile[0] && <h1 styleName="title">{planPageTitile[0]}</h1>}
          {planPageTitile[1] && <h2 styleName="title red">{planPageTitile[1]}</h2>}
          <h3 styleName="description">
            {planPageDescription} If you have any issue regarding subscription, please check out our{" "}
            <a styleName="red" href="/faq">
              FAQ section{" "}
            </a>
          </h3>
          <div styleName="tab">
            <button
              styleName={`${this.state.activeTab === "tab-1" ? "tab-btn-active" : ""} tab-btn-1 `}
              onClick={() => this.manageTab("tab-1")}
            >
              {this.props.member && getStandardUser && getStandardUser.length > 0 ? "₹ Renew" : "Subscribe"}
            </button>
            <button
              styleName={`${this.state.activeTab === "tab-2" ? "tab-btn-active" : ""} tab-btn-2 `}
              onClick={() => this.manageTab("tab-2")}
            >
              <GiftSubscription color={this.state.activeTab === "tab-2" ? "#ffffff" : "#231f20"} />
              <span styleName="gift-sub-text">Gift a subscription</span>
            </button>
          </div>
          <div styleName="layout">{this.getSubscriptionBlocks(groups)}</div>
        </div>
      </div>
    ) : null;
  }
}

SubscriptionTemplate.propTypes = {
  initAccessType: PropTypes.func,
  member: PropTypes.object,
  config: PropTypes.object,
  manageLoginForm: PropTypes.func,
  navigateTo: PropTypes.func,
  selectedPlan: PropTypes.func,
  paymentCheckout: PropTypes.func,
  getSubscriptionForUser: PropTypes.func,
  checkoutActiveTab: PropTypes.object
};

function SubscriptionBase(props) {
  const integrationsConfig = IntegrationData();
  const email = get(props, ["member", "email"], "");
  const phone = get(props, ["member", "metadata", "phone"], "");
  const isStaging = get(props.config, ["publisher", "publisher", "accessTypeEnvironment"], true);
  const enableAccesstype = get(props.config, ["publisher", "publisher", "enableAccesstype"], true);
  const accessTypeKey = isStaging? integrationsConfig.stagingAccessTypeKey : integrationsConfig.accessTypeKey;
  const accessTypeBkIntegrationId = isStaging? integrationsConfig.stagingAccessTypeBkIntegrationId : integrationsConfig.accessTypeBkIntegrationId;
  return (
    <div>
      <AccessType
        enableAccesstype={enableAccesstype}
        isStaging={isStaging}
        accessTypeKey={accessTypeKey}
        email={email}
        phone={phone}
        accessTypeBkIntegrationId={accessTypeBkIntegrationId}
      >
        {({ initAccessType, getSubscriptionForUser, accessIsLoading }) => {
          return (
            <SubscriptionTemplate
              initAccessType={initAccessType}
              accessIsLoading={accessIsLoading}
              getSubscriptionForUser={getSubscriptionForUser}
              {...props}
            />
          );
        }}
      </AccessType>
    </div>
  );
}

SubscriptionBase.propTypes = {
  config: PropTypes.object
};

const mapDispatchToProps = dispatch => ({
  manageLoginForm: function(payload) {
    dispatch({
      type: IS_OPEN_LOGIN_FORM,
      payload: payload
    });
  },
  navigateTo: url => global.app.navigateToPage(dispatch, url),
  selectedPlan: function(plan, redirectUrl, plans) {
    dispatch({
      type: SELECTED_PLAN,
      plan: plan,
      planType: "standard",
      redirectUrl: redirectUrl,
      subscriptionPlans: plans
    });
  },
  paymentCheckout: function(payload) {
    dispatch({
      type: PAYMENT_CHECKOUT_PAGE,
      payload: payload
    });
  }
});

const mapStateToProps = state => {
  return {
    config: get(state, ["qt", "config"], {}),
    subscriptions: get(state, ["subscriptions"], null),
    member: get(state, ["member"], null),
    checkoutActiveTab: get(state, ["paymentCheckout"], "subscription")
  };
};

export const Subscription = connect(mapStateToProps, mapDispatchToProps)(SubscriptionBase);
